export const LabsPreparationConfig = [
    { span: 14, height: "24px" }, // Row 1
    { span: 14, height: "70px", classes: "marginTop-8" }, // Row 3
]
